import { createRouter, createWebHistory } from 'vue-router'

// §18 / §19 — these are the only top-level routes. Everything a user reaches
// from inside an active Room (Profile, Product, Assets, Notes, Camera,
// Settings, Chat, Activity, Recording, NOW) is a Layer over MeetRoom, not a
// route, so it never appears here.
const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', name: 'meet-home', component: () => import('@/views/MeetHome.vue') },
    { path: '/new', name: 'meet-new', component: () => import('@/views/NewMeeting.vue') },
    { path: '/m/:roomCode', name: 'meet-room', component: () => import('@/views/MeetLobby.vue'), props: true },
    { path: '/history', name: 'meet-history', component: () => import('@/views/MeetHistory.vue') },
    {
      path: '/history/:meetingId',
      name: 'meet-history-detail',
      component: () => import('@/views/MeetHistoryDetail.vue'),
      props: true
    },
    { path: '/settings', name: 'meet-settings', component: () => import('@/views/MeetSettings.vue') },
    {
      path: '/cam/:pairToken',
      name: 'remote-camera-pair',
      component: () => import('@/views/RemoteCameraPair.vue'),
      props: true
    }
  ]
})

export default router
